export default "__VITE_ASSET__4h5EMBQB__"